// extracted by mini-css-extract-plugin
export default {"TimeUpOverlay":"timeUpOverlay_TimeUpOverlay__9CAQF","timer":"timeUpOverlay_timer__qnAsf"};